import React from 'react';
import { collaboratorTypes } from './collaborator.constant';
import Statistics from './Statistics';

const InstallatorStats = () => {
    return (
        <Statistics userType={collaboratorTypes.INSTALLATEUR} />
    );
};

export default InstallatorStats;